/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import { IProps, TStoreAvailabilities, TStoreAvailability, TStoreCombined } from './types';
import XTooltip, { BootstrapTooltip } from './tooltip';
import clsx from 'clsx';
import { getBucketName, getStoreTime, getWithInByText, getOrderMessage, getDeliveryMessage, getDisplayLabel, getTodayOrDate } from './functions';
import { useTypedSelector } from 'store/store';
import AvailabilityStoreView from '../AvailabilityStoreView';
import { IconButton } from '@mui/material';
import { LocationOn, Store } from '@mui/icons-material';
import PopupView from './PopupView';

const View: React.FC<IProps> = (props) => {
  const { avails, isFirst } = props;
  const user = useTypedSelector(state => state.user);
  const [showMobileUser, setShowMobileUser] = useState(false);
  const [storeAvails, setStoreAvails] = useState<TStoreAvailability | null>(null);

  const shipTo = user.userDetails.shipTos?.[0] || {};
  const storeNumber = (shipTo as any).storeNumber;
  const isWCCustomer = user.isWCCustomer;
  const deliveredBy = isWCCustomer ? `Available by` : 'Delivered by';
  const isMobileTruckUser = false || (user.userDetails.shipTos?.[0] as any)?.isMobileEnabled;

  const handleIsMobileTruckUser = (avail: TStoreAvailability) => {
    setStoreAvails(avail);
    setShowMobileUser(!showMobileUser);
  }

  const renderRow = (avail: TStoreAvailability) => {
    return isFirst ? (isWCCustomer && storeNumber === avail.store) ? <>
      <div className='avail-row'>
        <span className='highlighter cell'>{`${avail.storeQty}`}</span>
        <span className='underline'>{`${deliveredBy}`}</span>
        {`${getStoreTime(avail.storeTime)}`}
        <span onClick={() => handleIsMobileTruckUser(avail)} className={clsx('underline', { 'isMobile': isMobileTruckUser })}>{`${avail.bucket}`}</span>
      </div>
    </> : <>
      <div className='avail-row'>
        <span className='highlighter cell'>{avail.storeQty}</span>
        <span className='cell'>{getOrderMessage(avail, false)}</span>
      </div>
      <div className='avail-row'>
        {getDeliveryMessage(avail, isMobileTruckUser, handleIsMobileTruckUser, deliveredBy, false)}
      </div>
      {/* <div>{`Store: ${avail.store}`} - <span className='capitalize'>{avail.address}</span></div> */}
    </> : <>
      <span className='highlighter cell'>{`${avail.storeQty}`}</span>
      <span className='cell'>{getOrderMessage(avail, true)}</span>

      {getDeliveryMessage(avail, isMobileTruckUser, handleIsMobileTruckUser, deliveredBy, true)}
    </>
  }

  return <React.Fragment>
    {avails?.length > 0 ? avails.map((avail: TStoreAvailability) => {
      return <div className={clsx('avail-compact-view-item', { 'first-item': isFirst })}>
        {avail.validForMin && avail.validForMin > 0 ? <>
          {renderRow(avail)}
        </>
          : !avail.validForMin ? <>
            <span className='highlighter'>{`${avail.storeQty}`}</span><span className='underline'>{getWithInByText(avail)}</span>{`${getBucketName(avail)}`}
          </> : <>
            <span className='highlighter'>{`${avail.storeQty}`}</span> {isWCCustomer ? <><span className='underline'>{`${deliveredBy}`}</span>
              {`${getStoreTime(avail.storeTime)}`}
              <span className='underline'>{`${avail.bucket}`}</span></> :

              // Line shows servicing store of the user
              <>
                <span onClick={() => handleIsMobileTruckUser(avail)} className={clsx('underline', { 'isMobile': isMobileTruckUser })}>{`Order Now, `}</span>{`${avail.deliveredByDesc}`}
                {/* <div>{`Store: ${avail.store}`} - <span className='capitalize'>{avail.address}</span></div> */}
              </>
            }</>
        }</div>
    }) : <span className='disabled'>Currently out of stock</span>}
    {storeAvails && <AvailabilityStoreView openPopup={showMobileUser} storeData={storeAvails?.stores || []} closePopup={handleIsMobileTruckUser} />}
  </React.Fragment>
}




const AvailabilityCompactView: React.FC<IProps> = (props) => {
  const { avails, showFullList, showTooltip } = props;
  const [more, setMore] = useState<TStoreAvailabilities>([]);

  const deepAvails = _.clone(avails);
  const LEN = 4;
  const first: any = showFullList ? deepAvails : deepAvails?.length > 0 ? [deepAvails.shift()] : [];
  const remaining: TStoreAvailabilities = deepAvails;
  const isShowMore = remaining.length > LEN;

  const initialShowLess = () => {
    const _more = isShowMore ? remaining.slice(0, LEN) : remaining;
    setMore(_more);
  }

  useEffect(() => {
    initialShowLess();
  }, [avails]);

  const handleToggle = () => {
    const _more = remaining.length === more.length ? remaining.slice(0, LEN) : remaining;
    setMore(_more);
  }

  return <React.Fragment>
    <div className={clsx('avail-compact-view', { 'i-icon': true, 'full-list': showFullList })}>
      <View avails={first} isFirst={true} />
      <div className='compact-view-more'>
        {first && first.length > 0 && <BootstrapTooltip title={`Store: ${first[0].store} - ${first[0].address}`} placement='left'>
          <IconButton>
            <Store color='error' fontSize='small' />
          </IconButton>
        </BootstrapTooltip>}
        {(remaining?.length > 0 && !showFullList && showTooltip) ? <XTooltip isShowLess={remaining.length === more.length} showmore={isShowMore} toggleMore={handleToggle}>
          <PopupView avails={more} isFirst={false} />
        </XTooltip> : <span style={{ width: '36px' }}></span>}
      </div>
    </div>
  </React.Fragment>
}

export default AvailabilityCompactView;

export const constructTitles = (stores: TStoreCombined[]) => {
  // removed the first store from the list
  const rem = stores.slice(1);

  // rem.push({ store: stores[0].store, storeQty: stores[0].storeQty, address: stores[0].address });
  return <React.Fragment>
    <table className='store-tooltips'>
      <thead>
        <tr>
          <th>Qty</th>
          <th>Store Location</th>
        </tr>
      </thead>
      <tbody>
        {rem.map((store: TStoreCombined, i: number) => {
          return <tr key={`store-${i}-${store.store}`}>
            <td>{store.storeQty}</td>
            <td><Store color='error' fontSize='small' />{`${store.store}`} - <LocationOn color='error' fontSize='small' /> {`${store.address}`}</td>
          </tr>
        })}
      </tbody>
    </table>
  </React.Fragment>
}
